module.exports = {"id":"dp5_4l3q5","text":"Assessing Digital Competence Needs","instructions":"Which behaviour best shows prioritising digital learning opportunities?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"5.4","questionType":"PickOne","random":true,"options":[{"id":"dp5_4l3q5-a1","text":"Targeted learning plans","score":3},{"id":"dp5_4l3q5-a2","text":"Occasional tutorials","score":0.6},{"id":"dp5_4l3q5-a3","text":"General browsing","score":0.4}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.4/l3q5.json
// module id = 1348
// module chunks = 41